import { EMOJI_OPTIONS } from '../EmojiIcon';
import useCommentReactions from 'src/hooks/useComments';
import {
  CommentActionsChildrenProps,
  CommentActionsParentProps,
  CommentActionsProps,
} from '../CommentActions';
import ReactionItem from '../CommentReactionItem';

const QUICK_REACTION_EMOJIS = EMOJI_OPTIONS.filter((_, index) => index < 3);

interface CommentQuickReactionsProps {
  comment: any;
  parentEl: Record<string, any> | undefined;
  onAddReaction: CommentActionsProps['onAddReaction'];
  onRemoveReaction: CommentActionsProps['onRemoveReaction'];
}

const CommentQuickReactions = ({
  comment,
  parentEl,
  onAddReaction,
  onRemoveReaction,
}: CommentQuickReactionsProps) => {
  const isChildrenComment = !!parentEl;

  const { removeReact, addReact, hasUserReaction } = useCommentReactions({
    initialData: comment,

    onReactAdd: (reaction: any) => {
      if (isChildrenComment) {
        (onAddReaction as CommentActionsChildrenProps['onAddReaction'])(
          parentEl!.uuid,
          comment.uuid,
          reaction
        );
      } else {
        (onAddReaction as CommentActionsParentProps['onAddReaction'])(
          comment.uuid,
          reaction
        );
      }
    },

    onReactRemove: (reaction: any) => {
      if (isChildrenComment) {
        (onRemoveReaction as CommentActionsChildrenProps['onRemoveReaction'])(
          parentEl!.uuid,
          comment.uuid,
          reaction
        );
      } else {
        (onRemoveReaction as CommentActionsParentProps['onRemoveReaction'])(
          comment.uuid,
          reaction
        );
      }
    },
  });

  const handleToggleReaction = (emojiId: string) => {
    if (hasUserReaction(emojiId)) {
      removeReact(emojiId);
    } else {
      addReact(emojiId);
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'start',
        gap: 4,
      }}
    >
      {QUICK_REACTION_EMOJIS.map((emoji) => (
        <ReactionItem
          key={emoji.id}
          emoji={emoji}
          count={0}
          isUserReaction={false}
          onClick={handleToggleReaction}
          className="reaction-button border-none hoverable-reaction"
        />
      ))}
    </div>
  );
};

export default CommentQuickReactions;
